// actions.js
export const actions = [
  // Overdue - Urgent
  {
    title: "AWS Cloud Services",
    category: "Overdue - Urgent",
    overdueCount: 7,
    description: "Monthly cloud hosting and storage services",
    amountDue: 4250.0,
    dueDate: "2025-11-03",
    department: "Infrastructure",
    invoiceNumber: "INV001",
  },
  {
    title: "Office Supplies Co.",
    category: "Overdue - Urgent",
    overdueCount: 5,
    description: "Q4 office supplies and equipment",
    amountDue: 892.5,
    dueDate: "2025-11-05",
    department: "Office Supplies",
    invoiceNumber: "INV002",
  },

  // Leave Requests
  {
    id: 1,
    name: "Ashley Palma",
    category: "Leave Requests",
    leaveType: "Vacation Leave",
    days: 5,
    startDate: "2025-11-15",
    endDate: "2025-11-20",
    dateRequested: "2025-11-05",
    reason: "Family vacation to Japan",
    priority: "high",
  },
  {
    id: 2,
    name: "Clara Lee",
    category: "Leave Requests",
    leaveType: "Sick Leave",
    days: 2,
    startDate: "2025-11-10",
    endDate: "2025-11-11",
    dateRequested: "2025-11-08",
    reason: "Medical appointment",
    priority: "medium",
  },
  {
    id: 3,
    name: "Mark Lester Talatala",
    category: "Leave Requests",
    leaveType: "Personal Leave",
    days: 2,
    startDate: "2025-11-18",
    endDate: "2025-11-19",
    dateRequested: "2025-11-09",
    reason: "Personal matters",
    priority: "low",
  },

  // Due Soon
  {
    title: "Software Licensing Inc.",
    category: "Due Soon",
    dueSoonCount: 2,
    description: "Annual enterprise software licenses renewal",
    amountDue: 12500.0,
    dueDate: "2025-11-15",
    department: "Software",
    invoiceNumber: "INV003",
  },
  {
    title: "Marketing Agency Pro",
    category: "Due Soon",
    dueSoonCount: 1,
    description: "October marketing campaign services",
    amountDue: 3200.0,
    dueDate: "2025-11-18",
    department: "Marketing",
    invoiceNumber: "INV004",
  },

  // Tasks
  {
    title: "Q4 Performance Reviews",
    category: "Tasks",
    priority: "high",
    description: "Complete performance reviews for 12 team members",
    dueDate: "2025-11-20",
    department: "HR",
  },
  {
    title: "Budget Approval for 2026",
    category: "Tasks",
    priority: "high",
    description: "Review and approve department budget proposal",
    dueDate: "2025-11-25",
    department: "Finance",
  },
  {
    title: "Training Program Sign-off",
    category: "Tasks",
    priority: "medium",
    description: "Approve new employee onboarding training modules",
    dueDate: "2025-11-30",
    department: "Training",
  },
];
